// extracted by mini-css-extract-plugin
export default {"w-full":"CardInfo_w-full__RPBFF","line":"CardInfo_line__nd2Vr","info":"CardInfo_info__B5OGa","switch":"CardInfo_switch__DwarC"};